import { useState } from "react";

import { useTranslation } from "react-i18next";

import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";

/** Provide the RMA number eBay needs before it issues the label on a "Doesn't fit" return. */
export default function RmaPanel({ detail, onConfirm, onCancel, busy }: ReturnActionPanelProps) {
  const { t } = useTranslation("returns");
  // Wilma suggests the Tag no. plus a return counter, so the number means something in the warehouse.
  const suggested = detail.rma ?? (detail.part?.tagNumber ? `${detail.part.tagNumber}-R1` : "");
  const [rma, setRma] = useState(suggested);

  return (
    <ActionPanelFrame
      kind="provide_rma"
      detail={detail}
      canConfirm={rma.trim().length > 0}
      messageRequired={false}
      templateExtras={{ rma: rma.trim() }}
      onConfirm={(message) => onConfirm({ message, rmaNumber: rma.trim() })}
      onCancel={onCancel}
      busy={busy}
    >
      <label htmlFor="rma" className="text-[12px] text-gray-700">
        {t("RMA number")} <span className="text-gray-500">· {t("Wilma suggests Tag no. + return")}</span>
      </label>
      <input
        id="rma"
        type="text"
        value={rma}
        onChange={(e) => setRma(e.target.value)}
        disabled={busy}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 font-mono text-[13px] focus:border-primary-500 focus:ring-primary-500"
      />
    </ActionPanelFrame>
  );
}
